import { render } from "./Option.vue?vue&type=template&id=c3e50428&scoped=true&ts=true"
import script from "./Option.vue?vue&type=script&lang=ts"
export * from "./Option.vue?vue&type=script&lang=ts"

import "./Option.vue?vue&type=style&index=0&id=c3e50428&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e50428"]])

export default __exports__